import { render, staticRenderFns } from "./edition.vue?vue&type=template&id=2f4ee718&scoped=true"
import script from "./edition.vue?vue&type=script&lang=js"
export * from "./edition.vue?vue&type=script&lang=js"
import style0 from "./edition.vue?vue&type=style&index=0&id=2f4ee718&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ee718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4ee718')) {
      api.createRecord('2f4ee718', component.options)
    } else {
      api.reload('2f4ee718', component.options)
    }
    module.hot.accept("./edition.vue?vue&type=template&id=2f4ee718&scoped=true", function () {
      api.rerender('2f4ee718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/process/views/process_map/components/edition/edition.vue"
export default component.exports